import React, { useState, useMemo, useCallback } from 'react';
import PropTypes from 'prop-types';
import { DASHBOARD_SHAPE } from './utils/dashboardHelpers';
import { DashboardSelector } from './components/DashboardSelector';
import { DashboardEmbed } from './components/DashboardEmbed';
import './dashboard.scss';

export const Dashboard = ({ dashboards }) => {
    const [selectedReportId, setSelectedReportId] = useState(dashboards[0]?.reportId);

    const selectorOptions = useMemo(
        () => dashboards.map((dashboard) => ({ value: dashboard.reportId, label: dashboard.title })),
        [dashboards]
    );

    const handleSelect = useCallback((option) => {
        setSelectedReportId(option.value);
    }, []);

    const selectedDashboard = dashboards.find((dashboard) => dashboard.reportId === selectedReportId);

    if (!selectedDashboard) return null;

    return (
        <div className="dashboard">
            {dashboards.length > 1 && (
                <DashboardSelector
                    options={selectorOptions}
                    value={selectorOptions.find((option) => option.value === selectedReportId)}
                    onChange={handleSelect}
                />
            )}
            <DashboardEmbed dashboard={selectedDashboard} />
        </div>
    );
};

Dashboard.propTypes = {
    dashboards: PropTypes.arrayOf(DASHBOARD_SHAPE).isRequired,
};

export default Dashboard;
